<template>
  <div class="content w-100 h-100">
    <BIconLock scale="3" class="lockicon m-4 h-50"> </BIconLock>
    <h5 class="mx-auto h-50">
      You currently don't have permission to access this content
    </h5>
  </div>
</template>
<script>
// import axios from "axios";
import { BIconLock } from "bootstrap-vue";

export default {
  components: { BIconLock },
  computed: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style>
.content {
  text-align: center;
}
.lockicon {
  color: rgb(78, 205, 196);
}
</style>
